/**
 * Hero Swiper Slider
 */
import { Swiper } from 'swiper';
import { Navigation, Autoplay, EffectFade } from 'swiper/modules';

export function initHeroSlider() {
    if (!document.querySelector('#heroSwiper')) return;
    
    const heroSwiper = new Swiper('#heroSwiper', {
        modules: [Navigation, Autoplay, EffectFade],
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '#heroNext',
            prevEl: '#heroPrev',
        },
        on: {
            slideChange: function() {
                updateHeroTags(this.realIndex);
            }
        }
    });
    
    // Function to update hero tags
    function updateHeroTags(slideIndex) {
        const tags = document.querySelector('.acc_hero__tags');
        if (!tags) return;
        
        const tagData = [
            { category: 'SOCIAL MÉDIA', type: 'VIDÉO' },
            { category: 'BRANDING', type: 'PHOTO' },
            { category: 'WEB', type: 'VIDÉO' },
            { category: 'PRINT', type: 'PHOTO' }
        ];
        
        const currentTags = tagData[slideIndex] || tagData[0];
        const categoryTag = tags.querySelector('.acc_hero__tag--category');
        const typeTag = tags.querySelector('.acc_hero__tag--type');
        
        if (categoryTag) categoryTag.textContent = currentTags.category;
        if (typeTag) typeTag.textContent = currentTags.type;
    }
}